
import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import WhyChooseUs from './components/WhyChooseUs';
import Footer from './components/Footer';
import QuoteForm from './components/QuoteForm';
import Header from './components/Header';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import FloatingAI from './components/FloatingAI';
import AboutUs from './components/AboutUs';
import BrandStrip from './components/BrandStrip';
import { siteConfig } from '../../config/site';

const HomePage = () => {
  const isEletrodomesticosSite = siteConfig.domain === 'alphaservices.pt';
  const isClimatizacaoSite = siteConfig.domain === 'alphaclimatizacao.pt';

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      {isClimatizacaoSite && <BrandStrip />}
      <Services />
      {siteConfig.domain !== 'alphaservices.pt' && <HowItWorks />}
      <div id="avaliacoes">
        <Testimonials />
      </div>
      {isEletrodomesticosSite && <AboutUs />}
      <WhyChooseUs />
      {/* Form at the end of the page (Oculto para Eletrodomésticos) */}
      {siteConfig.domain !== 'alphaservices.pt' && (
        <section className="py-16 bg-gray-50" id="orcamento">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-2xl shadow-2xl p-8">
              <QuoteForm />
            </div>
          </div>
        </section>
      )}
      {/* Zonas Atendidas (movido para mais abaixo) */}
      <div id="zonas">
        <ServiceAreas />
      </div>
      {!isEletrodomesticosSite && !isClimatizacaoSite && <FloatingAI />}
      <FloatingWhatsApp />
      <Footer />
    </div>
  );
};

export default HomePage;
